"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageFourForcedContent;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageFourForcedContent(_ref) {
  var {
    socialSecurityBenefit
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "eyebrow"
  }, "Average Social Security Benefit"), /*#__PURE__*/_react.default.createElement("h2", {
    className: "margin-top-0"
  }, (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, socialSecurityBenefit)), ' ', "/month")), /*#__PURE__*/_react.default.createElement("p", null, "This is the average benefit. If you prefer, you can use a more detailed estimate of your", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.ssa.gov/OACT/FACTS/",
    target: "_blank",
    rel: "noreferrer"
  }, "Social Security benefit.", /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-external-link icon-margin-left"
  }))));
}